var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "sidePanel",
      class: { "is-rtl": _vm.isRtl, "is-mobile": _vm.isMobile },
      attrs: { tabindex: 0 },
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closePanel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "transition",
        { attrs: { name: "side-panel" } },
        [
          _c(
            "KFocusTrap",
            {
              on: {
                shouldFocusFirstEl: _vm.focusFirstEl,
                shouldFocusLastEl: _vm.focusLastEl,
              },
            },
            [
              _c(
                "section",
                {
                  staticClass: "side-panel",
                  style: _vm.sidePanelStyles,
                  attrs: { role: "region", "aria-label": _vm.ariaLabel },
                },
                [
                  _c(
                    "div",
                    {
                      ref: "fixedHeader",
                      class: {
                        "side-panel-header": true,
                        immersive: _vm.immersive,
                      },
                      style: _vm.headerStyles,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "header-content",
                          style: {
                            flexDirection:
                              _vm.closeButtonIconType === "close"
                                ? "row"
                                : "row-reverse",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { overflow: "hidden" } },
                            [_vm._t("header")],
                            2
                          ),
                          _vm.closeButtonIconType
                            ? _c("KIconButton", {
                                staticClass: "close-button",
                                attrs: {
                                  icon: _vm.closeButtonIconType,
                                  ariaLabel: _vm.closeButtonMessage,
                                  tooltip: _vm.closeButtonMessage,
                                },
                                on: { click: _vm.closePanel },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "side-panel-content",
                      on: {
                        scroll: function ($event) {
                          _vm.isScrolled = $event.target.scrollTop > 0
                        },
                      },
                    },
                    [_vm._t("default", null, { isScrolled: _vm.isScrolled })],
                    2
                  ),
                  _vm.$slots.bottomNavigation
                    ? _c(
                        "div",
                        {
                          ref: "fixedBottombar",
                          staticClass: "bottom-navigation",
                          style: { backgroundColor: _vm.$themeTokens.surface },
                        },
                        [_vm._t("bottomNavigation")],
                        2
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("Backdrop", {
        staticClass: "backdrop",
        attrs: { transitions: true },
        on: { click: _vm.closePanel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }